var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"m_footer",attrs:{"height":"29px"}},[_vm._v(_vm._s(_vm.cpString))])}
var staticRenderFns = []

export { render, staticRenderFns }